import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareClassicProformaIssueFormsDirectRoute } from '@jira/router-routes__classic-projects-routes/src/softwareClassicProformaIssueFormsDirectRoute.tsx';
import { classicSoftwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { proformaIssueFormsDirectPageEntryPoint } from './ui/proforma/issue-forms-direct/index.tsx';

export const softwareClassicProformaIssueFormsDirectRouteEntry: Route = createEntry(
	softwareClassicProformaIssueFormsDirectRoute,
	() => ({
		group: 'classic-software',
		layout: classicSoftwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
		},

		// eslint-disable-next-line jira/router/no-project-context-resource
		resources: [projectContextResource],
		entryPoint: () => proformaIssueFormsDirectPageEntryPoint,
		perfMetricKey: 'issue-forms-direct',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
